export default __webpack_public_path__ + "static/proxima-nova-100-i-b10720f06eeb38d81661d3c905f1fb68.woff";